/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuthorizedPiracyAuthorizedListPiracyProtocolsAddAuthorizedListRequest,
  AuthorizedPiracyAuthorizedListPiracyProtocolsDeleteAuthorizedListRequest,
  AuthorizedPiracyAuthorizedListPiracyProtocolsExportAuthorizedListRequest,
  AuthorizedPiracyAuthorizedListPiracyProtocolsGetAllAuthorizedListIdListRequest,
  AuthorizedPiracyAuthorizedListPiracyProtocolsGetAllAuthorizedListIdListResponse,
  AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListCountRequest,
  AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListCountResponse,
  AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListRequest,
  AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListResponse,
  AuthorizedPiracyAuthorizedListPiracyProtocolsGetPlatformFilterRequest,
  AuthorizedPiracyAuthorizedListPiracyProtocolsGetPlatformFilterResponse,
  MarqCommonProtocolFileResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AuthorizedListPiracy<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AuthorizedListPiracy
   * @name AuthorizedListListCreate
   * @request POST:/piracy/authorized-list/list
   */
  authorizedListListCreate = (
    data: AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListResponse, any>({
      path: `/piracy/authorized-list/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthorizedListPiracy
   * @name AuthorizedListCountCreate
   * @request POST:/piracy/authorized-list/count
   */
  authorizedListCountCreate = (
    data: AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListCountRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<AuthorizedPiracyAuthorizedListPiracyProtocolsGetAuthorizedListCountResponse, any>({
      path: `/piracy/authorized-list/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthorizedListPiracy
   * @name AuthorizedListFilterPlatformCreate
   * @request POST:/piracy/authorized-list/filter/platform
   */
  authorizedListFilterPlatformCreate = (
    data: AuthorizedPiracyAuthorizedListPiracyProtocolsGetPlatformFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<AuthorizedPiracyAuthorizedListPiracyProtocolsGetPlatformFilterResponse, any>({
      path: `/piracy/authorized-list/filter/platform`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthorizedListPiracy
   * @name AuthorizedListGetAllIdCreate
   * @request POST:/piracy/authorized-list/get-all-id
   */
  authorizedListGetAllIdCreate = (
    data: AuthorizedPiracyAuthorizedListPiracyProtocolsGetAllAuthorizedListIdListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<AuthorizedPiracyAuthorizedListPiracyProtocolsGetAllAuthorizedListIdListResponse, any>({
      path: `/piracy/authorized-list/get-all-id`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthorizedListPiracy
   * @name AuthorizedListExportCreate
   * @request POST:/piracy/authorized-list/export
   */
  authorizedListExportCreate = (
    data: AuthorizedPiracyAuthorizedListPiracyProtocolsExportAuthorizedListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/piracy/authorized-list/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthorizedListPiracy
   * @name AuthorizedListAddCreate
   * @request POST:/piracy/authorized-list/add
   */
  authorizedListAddCreate = (
    data: AuthorizedPiracyAuthorizedListPiracyProtocolsAddAuthorizedListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/piracy/authorized-list/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthorizedListPiracy
   * @name AuthorizedListDeleteCreate
   * @request POST:/piracy/authorized-list/delete
   */
  authorizedListDeleteCreate = (
    data: AuthorizedPiracyAuthorizedListPiracyProtocolsDeleteAuthorizedListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/piracy/authorized-list/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
